import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const ASPECTS = [
  { id: "1:1", label: "Square · 1:1" },
  { id: "4:3", label: "Landscape · 4:3" },
  { id: "3:4", label: "Portrait · 3:4" },
  { id: "16:9", label: "Cinema · 16:9" },
  { id: "9:16", label: "Vertical · 9:16" },
  { id: "21:9", label: "Ultra-Wide · 21:9" },
  { id: "2:3", label: "Poster · 2:3" },
  { id: "3:2", label: "Photo · 3:2" },
];

export const IMAGE_RESOLUTIONS = [
  { id: "HD", label: "HD · 1280×720" },
  { id: "FHD", label: "Full HD · 1920×1080" },
  { id: "2K", label: "2K · 2560×1440" },
  { id: "4K", label: "4K · 3840×2160" },
];

export const VIDEO_RESOLUTIONS = [
  { id: "480p", label: "480p · Fast" },
  { id: "720p", label: "720p · Standard" },
  { id: "1080p", label: "1080p · Cinema" },
];

const VIDEO_ASPECTS = new Set(["16:9", "9:16", "1:1"]);

/**
 * Aspect Ratio + Resolution card, shared across all generation modes.
 * Video modes filter aspects to Seedance-supported and show a Video Resolution picker.
 * Image (create) mode shows the 1K/2K/4K image Resolution picker.
 */
export function AspectRatioCard({
  mode,
  aspect,
  setAspect,
  resolution,
  setResolution,
  videoResolution,
  setVideoResolution,
}) {
  const isVideo = mode === "text-video" || mode === "video-to-video";
  const aspects = isVideo ? ASPECTS.filter((a) => VIDEO_ASPECTS.has(a.id)) : ASPECTS;
  const showImageResolution = mode === "create" || mode === "pipeline";
  return (
    <div className="p-6 rounded-2xl bg-[#120E15] border border-[#F2C94C]/15 space-y-4" data-testid="aspect-card">
      <div>
        <label className="font-mono-hy text-[10px] text-white block mb-2">Aspect Ratio</label>
        <Select value={aspect} onValueChange={setAspect}>
          <SelectTrigger data-testid="aspect-select" className="bg-[#0A0A0A] border-[#F2C94C]/20 focus:border-[#00E5FF] font-body">
            <SelectValue />
          </SelectTrigger>
          <SelectContent className="bg-[#120E15] border-[#F2C94C]/20">
            {aspects.map((a) => (
              <SelectItem key={a.id} value={a.id} className="font-body" data-testid={`aspect-option-${a.id.replace(":", "x")}`}>{a.label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      {showImageResolution && (
        <div>
          <label className="font-mono-hy text-[10px] text-white block mb-2">Resolution</label>
          <Select value={resolution} onValueChange={setResolution}>
            <SelectTrigger data-testid="resolution-select" className="bg-[#0A0A0A] border-[#F2C94C]/20 focus:border-[#00E5FF] font-body">
              <SelectValue />
            </SelectTrigger>
            <SelectContent className="bg-[#120E15] border-[#F2C94C]/20">
              {IMAGE_RESOLUTIONS.map((r) => (
                <SelectItem key={r.id} value={r.id} className="font-body" data-testid={`resolution-option-${r.id}`}>{r.label}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      )}
      {isVideo && (
        <div>
          <label className="font-mono-hy text-[10px] text-white block mb-2">Video Resolution</label>
          <Select value={videoResolution} onValueChange={setVideoResolution}>
            <SelectTrigger data-testid="video-resolution-select" className="bg-[#0A0A0A] border-[#F2C94C]/20 focus:border-[#00E5FF] font-body">
              <SelectValue />
            </SelectTrigger>
            <SelectContent className="bg-[#120E15] border-[#F2C94C]/20">
              {VIDEO_RESOLUTIONS.map((r) => (
                <SelectItem key={r.id} value={r.id} className="font-body">{r.label}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      )}
    </div>
  );
}
